import { saveAs } from 'file-saver'
import { getObjectUrl, getObjectForDownload } from 'utils/mediaUtils'
import { importWithReload } from 'utils/chunkLoadUtils'

export const downloadStlsAsZip = async ({ upper, lower, scanNumber }) => {
  const { default: JSZip } = await importWithReload(() => import('jszip'))
  const [upperBlob, lowerBlob] = await Promise.all([
    getObjectForDownload(getObjectUrl(upper)),
    getObjectForDownload(getObjectUrl(lower))
  ])
  // getObjectForDownload resolves `undefined` on any fetch/auth failure (it never throws),
  // and JSZip silently accepts undefined content — so without this guard a failed download
  // produces an empty ZIP with no error surfaced. Fail loudly so the caller shows the error toast.
  if (!upperBlob || !lowerBlob) {
    throw new Error('Failed to download one or both STL files')
  }
  const zip = new JSZip()
  zip.file('upper.stl', upperBlob)
  zip.file('lower.stl', lowerBlob)
  const blob = await zip.generateAsync({ type: 'blob' })
  saveAs(blob, `scan-${scanNumber}-stls.zip`)
}
